function getKind(uid) {
  return uid.split('_')[0];
}

export default getKind;
